import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/shared/services/loader.service';
@Component({
    selector: 'app-page-loader',
    templateUrl: './page-loader.component.html',
    styleUrls: ['./page-loader.component.scss']
})
export class PageLoaderComponent implements OnInit {
    @Input() showLoader!: boolean
    constructor(private spinnerService: NgxSpinnerService, public loaderService: LoaderService) {       
   
    }
    
    
ngOnInit() {
    this.loaderService.loading$.subscribe(data => {
      this.showLoader = data;
      if(this.showLoader) { 
        this.spinnerService.show();
    } else {
        this.spinnerService.hide();
    }
    });
  }


}
